export default "__VITE_ASSET__4a8be18b__"